





























import { Component, Prop, Watch } from "vue-property-decorator";

import { UserFormBaseAdminInterface } from "@service/components/user-form-base/interfaces/UserFormBaseAdminInterface";
import UserFormBase from "@service/components/user-form-base/UserFormBase.vue";
import SettingsForm from "@service/components/settings/SettingsForm.vue";
import PocketBlock from "@share/common/pocket/Pocket.vue";
import SegmentControl from "@share/common/segment/Segment.vue";
import SettingsHeader from "@service/components/settings/components/header/SettingsHeader.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";

import { UserRepository } from "@api/repositories/UserRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { PropertiesInterface } from "@api/models/settings/PropertiesInterface";
import { SettingRepository } from "@api/repositories/SettingRepository";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { UserProfileInterface } from "@api/models/interfaces/UserProfileInterface";
import { EventMembershipRepository } from "@api/repositories/EventMembershipRepository";

import { UserCreateEditService } from "@share/common/services/userCreateEdit/UserCreateEditService";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { Notice } from "@service/components/toast/type/Notice";
import { noticeActions } from "@service/store/notice/actions";
import { UserCreateEditServiceInterface } from "@share/common/services/userCreateEdit/interfaces/UserCreateEditServiceInterface";
import { deepCopy } from "@common/ObjectsHelper";

@Component({ components: { PocketBlock, SegmentControl, SettingsForm, SettingsHeader, BounceSpinner, Overlay }})

export default class UserCreate extends UserFormBase implements UserFormBaseAdminInterface {
    onLoading = false;
    isLoaded = false;

    @Prop({ required: true }) userIdForEdit: number | null;

    usersRepository: UserRepository = this.$repositories.get(RepositoryFabric.USER);
    settingRepository: SettingRepository = this.$repositories.get(RepositoryFabric.SETTING);
    objectRepository: ObjectRepository = this.$repositories.get(RepositoryFabric.OBJECT);
    eventMembershipRepository: EventMembershipRepository = this.$repositories.get(RepositoryFabric.EVENT_MEMBERSHIP);

    userCodes?: Set<string>;
    codeGenerationSettings?: PropertiesInterface;

    userCreateEditService: UserCreateEditServiceInterface | null;

    created() {
        this.userCreateEditService = new UserCreateEditService(
            this.$repositories.get(RepositoryFabric.USER),
            this.$repositories.get(RepositoryFabric.SETTING),
            this.$repositories.get(RepositoryFabric.OBJECT),
            this.$repositories.get(RepositoryFabric.EVENT_MEMBERSHIP)
        )
    }

    async mounted() {
        this.initialize();
    }

    async initialize() {
        if(!this.userCreateEditService) {
            throw new Error("userCreateEditService is not exist")
        }

        this.user = this.userCreateEditService.getnewUser(this.lang);
        this.onLoading = true;

        try {
            if(this.userIdForEdit) {

                const userId = this.userIdForEdit;

                if(!userId) {
                    return
                }

                const [profile, user] = await Promise.all([
                    this.usersRepository.profile(userId),
                    this.usersRepository.user(userId)
                ]);

                if(user && profile) {
                    this.user = user;
                    this.userId = user.id;
                    this.profile = profile;
                }
            }

            if(!this.user.id) {
                this.user = this.userCreateEditService.getnewUser(this.lang)
            }

            await this.loadData();
        }
        catch(e) {
            this.$store.dispatch("reportError", e);
        }
        finally {
            this.onLoading = false;
        }
    }

    async loadData() {
        this.getProfileParamsAndSetFieldsAndTags();

        this.isLoaded = true;
    }

    async save() {
        this.validationMessages = {};

        if(!this.validate(this.needValidateTags)) {
            return false
        }

        this.onLoading = true;

        //ветвление на создание и редактирование
        //обработка ошибок и отправка уведомлений
        if(this.userIdForEdit) {
            try {
                this.profile.updatedAt = undefined;

                await Promise.all([
                    this.userCreateEditService?.updateProfile(this.profile),
                    this.userCreateEditService?.updateUser(this.user)
                ])

                this.$emit('updateProfile', this.profile);

                this.handleSuccess(
                    this.$t("participants.form.success", { action: this.$t("participants.form.actions.edit.success") }).toString()
                );
            }
            catch(e) {
                this.$store.dispatch("reportError", e);

                this.handleFail(this.$t("participants.form.fail", {action: this.$t("participants.form.actions.edit.fail") }).toString());
            }
        }
        else {
            try {
                await this.userCreateEditService?.createUserAndAddToEvent(this.eventId, this.profileDataFromUserProfile, this.user);
                this.$emit('createProfile', this.profile);

                this.handleSuccess(this.$t("participants.form.success", { action: this.$t("participants.form.actions.create.success") }).toString());
            }
            catch(e) {
                this.$store.dispatch("reportError", e);

                this.handleFail(this.$t("participants.form.fail", { action: this.$t("participants.form.actions.create.fail") }).toString());
            }
        }

        this.onLoading = false;
        this.close();
    }

    handleSuccess(message: string) {
        const notice: Notice = {
            text: message,
            level: NoticeLevel.success
        }

        this.$store.dispatch(noticeActions.submitNotice, notice);
    }

    handleFail(message: string) {
        const notice: Notice = {
            text: message,
            level: NoticeLevel.danger
        }

        this.$store.dispatch(noticeActions.submitNotice, notice);
    }

    validate(tagsRequired = true) {

        if(!this.isLoaded) { return true; }

        let valid = true;

        this.validationMessages = {};

        valid = this.validateBase(tagsRequired);

        this.valid = valid;

        return valid;
    }

    @Watch("userIdForEdit")
    watchIsEditModeHandler(userIdForEdit: number | null) {
        if(!userIdForEdit) {
            this.resetForm();
        }

        this.initialize();
    }

    close() {
        this.$emit('close');
    }

    get buttonText() {
        return this.isEditMode ? undefined : this.$t("participants.form.createUser")
    }

    get profileDataFromUserProfile(): UserProfileInterface {
        const profile: UserProfileInterface = deepCopy(this.profile);

        delete profile.id;

        return profile;
    }

    get eventId(): string {
        return this.$store.state.events.selected;
    }

    get isEditMode() {
        return !!this.userIdForEdit;
    }
}

